import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = '查看全部' }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2.5 font-heading text-xl font-800 text-foreground-950 md:text-2xl">
          <span className="flex h-6 w-1.5 rounded-full bg-accent-500" />
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 pl-4 text-sm font-label text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm font-label font-500 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}